import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RestablecerContrasenaComponent } from './restablecer-contrasena.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxTextBoxModule } from 'devextreme-angular';
import { ValidationErrorMessagePipe } from 'src/app/_helpers/validacion-form.service';

@NgModule({
  declarations: [RestablecerContrasenaComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DxTextBoxModule,
    ValidationErrorMessagePipe,
  ],
  exports: [RestablecerContrasenaComponent],
})
export class RestablecerContrasenaModule {}
